
<form [formGroup]="searchForm">
  <pim-input-input [id]="'searchQuery'+id" label="Suche" formControlName="searchQuery">
    <ng-container ngProjectAs="label">
      @if (tooltipText !== '' && !viewOnly) {
        <pim-tooltip class="ml-2" [tooltipText]="tooltipText"></pim-tooltip>
      }
    </ng-container>
  </pim-input-input>
</form>